import { PlaceholderPage } from "@/components/placeholder/PlaceholderPage";
import { TrendingUp } from "lucide-react";
import { MainLayout } from "@/components/MainLayout";

export default function LawFirmsPerformancePage() {
  return (
<MainLayout>
    <PlaceholderPage
      title="Relatório de Performance"
      description="Análise de performance do seu escritório de advocacia."
      icon={TrendingUp}
    />
  
    </MainLayout>);
}

